import { createTheme } from "@mui/material";
import { fontStyles } from "./fontStyles";
import c from "lib/style/colorVar.scss";

export const theme = createTheme({
  typography: {
    fontFamily: "Noto Sans, Roboto, sans-serif",
    ...fontStyles,
  },
  components: {
    MuiTypography: {
      defaultProps: {
        fontFamily: "Noto Sans, Roboto, sans-serif",
        color: c["black"],
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          variants: [
            {
              props: { variant: "auth-button" },
              style: () => ({
                backgroundColor: c["yellow"],
                color: c["yellowWordings"],
                height: "45px",
                width: "100%",
                borderRadius: "32px",
                border: "none",
                marginTop: "16px",
                marginBottom: "16px",
                cursor: "pointer",
                ":disabled": {
                  backgroundColor: c["yellowHover"],
                },
                ":hover": {
                  backgroundColor: "#f1bf0c",
                },
              }),
            },
            {
              props: { variant: "normal-button" },
              style: () => ({
                backgroundColor: c["brandDark12"],
                color: "white",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                ":disabled": {
                  backgroundColor: c["brandLight25"],
                  color: "white",
                },
                ":hover": {
                  backgroundColor: c["brandLight25"],
                },
              }),
            },
            {
              props: { variant: "outline-normal-button" },
              style: () => ({
                backgroundColor: "white",
                color: "grey",
                borderRadius: "4px",
                border: "grey solid 1px",
                cursor: "pointer",
                ":disabled": {
                  color: c["brandLight25"],
                  borderColor: c["brandLight25"],
                  border: `solid 1px ${c["brandLight25"]}`,
                },
                ":hover": {
                  color: c["brandLight25"],
                  borderColor: c["brandLight25"],
                  border: "solid 1px",
                },
              }),
            },
          ],
        },
      },
    },
  },
});
